import { useEffect, useState, startTransition } from 'react'

/**
 * Client-side render kontrolü için hook
 * SSR sırasında false, client-side hydration sonrası true döner
 * @returns {boolean} Client-side'da olup olmadığı
 */
export function useIsClient(): boolean {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    startTransition(() => {
      setIsClient(true)
    })
  }, [])

  return isClient
}
